import { strIsNullOrEmpty } from '@fox/atoms/utils/string';
import { TextField } from '@fox/atoms/src/text-field/index';
import { Extension } from '@fox/extensions/src/extension-components';
import { useEffect } from 'react';
import { useAutoDataGridContext } from '../../auto-data-grid/context';
import { FilterExtensionProps } from '../../contracts/filters';
import { FilterConditionItemProps } from './types';

export function FilterComponent<T>({
	filter,
	editFilter,
	filterParams: providedFilterParams
}: Pick<FilterConditionItemProps<T>, 'filter' | 'filterParams'> & { editFilter: (e: unknown) => void }) {
	const { filterParams, addColumnFilterParams, loading } = useAutoDataGridContext() ?? {};

	const filterParam = filterParams?.[filter.dataIndex];
	const hasFilterParams = !!filterParam;

	useEffect(() => {
		if (!hasFilterParams && !loading && (filter.filterType === 'select' || filter.filterType === 'treeselect' || filter.filterType === 'link')) {
			addColumnFilterParams?.(filter.dataIndex, filter.filterType);
		}
	}, [filter.filterType, filter.dataIndex, hasFilterParams]);

	if (strIsNullOrEmpty(filter.filterType)) {
		return <TextField size="small" value={''} onChange={e => {}} />;
	} else {
		return (
			<Extension<FilterExtensionProps>
				name={`column-filter-${filter.filterType}`}
				props={{
					value: filter.constV,
					setValue: (value: unknown) => editFilter(value),
					filterParams: filterParams?.[filter.dataIndex] ?? providedFilterParams
				}}
			/>
		);
	}
}
